<div class="p-6">
  <h1 class="text-xl font-bold mb-5">
    {{ 'player-content.icon-and-name' | translate }}
  </h1>
  <rk-page-icon-and-name-editor [pageIndex]="0"></rk-page-icon-and-name-editor>
  <rk-page-name-error></rk-page-name-error>
</div>
<rk-setting-divider></rk-setting-divider>
<rk-setting-container [name]="'player-content.stream' | translate">
  <fa-icon
    headerActions
    [icon]="'magnifying-glass'"
    class="text-sm opacity-50 cursor-pointer hover:opacity-80"
    (click)="$event.stopPropagation(); streamList.toggleSearch()"
  ></fa-icon>
  <!-- sort icon: opacity-50 + hover when enabled, opacity-20 when search is active -->
  <fa-icon
    headerActions
    [icon]="'arrow-down-a-z'"
    class="text-sm cursor-pointer"
    [class.opacity-50]="!streamList.searchQuery"
    [class.hover:opacity-80]="!streamList.searchQuery"
    [class.opacity-20]="!!streamList.searchQuery"
    (click)="$event.stopPropagation(); !streamList.searchQuery && streamList.sortAlphabetically()"
  ></fa-icon>
  <rk-stream-list #streamList></rk-stream-list>
</rk-setting-container>
<rk-setting-divider></rk-setting-divider>
<rk-player-buttons></rk-player-buttons>
